export default "__VITE_ASSET__CMjz7KEy__"